export const ALL_STAFF_BUTTON_TEXT = 'Prepare for All-Staff'
export const FAMILIES_BUTTON_TEXT = 'Inform Families'
export const GET_STARTED_BUTTON_TEXT = 'Get Started'
export const GET_STARTED_BUTTON_TEST_ID = 'get-started-button'
export const GOALS_TEXT = 'Add Goals'
export const HEADER_TEXT_DEFAULT = 'Set Up for 2026-27'
export const HEADER_TEXT_SUMMARY = 'Setup Complete!'
export const IMPLEMENTATION_APPROACH_TEXT = 'Choose Approach'
export const MARK_COMPLETE_BUTTON_TEXT = 'Mark Complete'
export const PAGE_CONTENT_TEST_ID = 'playbook-steps-page-content'
export const PURPOSE_TEXT = 'Add Your Purpose'
export const RESUME_BUTTON_TEXT = 'Resume'
export const SET_GOAL_TEST_ID = 'set-goal-button'
export const SUMMARY_LINK_TEXT = 'View 2026-27 Setup'
